import { AfterViewInit, ChangeDetectorRef, Component, Input } from '@angular/core';
import {MatTooltipModule} from '@angular/material/tooltip';
@Component({
  selector: 'app-cards-cliente',
  templateUrl: './cards-cliente.component.html',
  styleUrls: ['./cards-cliente.component.scss']
})
export class CardsClienteComponent implements AfterViewInit {
 @Input() isResellers :boolean = false;
 @Input() resellersGold :any = [];
 @Input() resellers :any = [];;
 @Input() allAssistances :any = [];

 constructor (private cdr: ChangeDetectorRef){
 }


  ngAfterViewInit(){
    this.scrollToTop();
  }

 scrollToTop() {
  window.scrollTo({ top: 0, behavior: 'smooth'});
}
}
